import { CompassCalibration, Dangerous, DirectionsWalk, DonutSmall, Dvr, FiberDvr, FileDownload, FileUpload, HelpOutline, Hiking, MotionPhotosAuto, Settings, WavingHand, WavingHandOutlined, Wifi2Bar } from "@mui/icons-material";
import { RobotAgent, RobotConnectionState } from "../../panels/worldpanelparts/robot/RobotAgent";
import { RobotButton } from "./RobotButton";
import { useEffect, useState } from "react";
import { AgentEvents } from "../../panels/worldpanelparts/agents/BaseAgent";
import { NavMode, RobotPostureMode, RobotRecordingStatus } from "../../api/robocore/dex_interfaces";
import { DeploymentContext } from "./DeploymentPage";

export function UniversalToolbar({ ctx, setCtx }: { 
  ctx: DeploymentContext;
  setCtx: (ctx: DeploymentContext) => void;
}) {
  const [a, setA] = useState(ctx.agent!);
  useEffect(() => {
    if (!ctx.agent) return;
    const listener = (dgram: Partial<RobotAgent>) => {
      setA({ ...ctx.agent } as any);
    };
    ctx.agent.on(AgentEvents.StateChange, listener);
    return () => {
      ctx.agent?.off(AgentEvents.StateChange, listener);
    };
  }, [ctx.agent]);
  const agent = ctx.agent!;
  const { connectionState, postureMode } = a;
  // need a gap between the two buttons
  // the buttons should align to center vertically
  const color = 'error';
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <RobotButton select id={`robot-button-nav-mode`} color={color} actions={[
        {
          name: 'Manual',
          Icon: <DonutSmall color={color} style={{ transform: 'rotate(90deg)' }} fontSize="large" />,
          onClick: () => agent.switchNavMode(NavMode.Manual),
          active: a.navMode === NavMode.Manual,
        },
        {
          name: 'SLAM',
          Icon: <CompassCalibration color={color} fontSize="large" />,
          onClick: () => agent.switchNavMode(NavMode.SLAM),
          active: a.navMode === NavMode.SLAM,
        },
        {
          name: 'Autonomous',
          Icon: <MotionPhotosAuto color={color} fontSize="large" />,
          onClick: () => agent.switchNavMode(NavMode.Auto),
          active: a.navMode === NavMode.Auto,
        },
        {
          name: 'Unknown',
          Icon: <HelpOutline color={color} fontSize="large" />,
          onClick: () => { },
          active: a.navMode === NavMode.Unknown,
          disabled: true,
        }
      ]} />
      <RobotButton
        color={color}
        id={`robot-button-postureMode`}
        select
        actions={[
          {
            name: 'Stand down',
            Icon: <FileDownload color={color} fontSize="large" />,
            onClick: () => agent.requestPostureMode(RobotPostureMode.StandDown),
            active: postureMode === RobotPostureMode.StandDown,
            disabled: postureMode === RobotPostureMode.StandDown
          },
          {
            name: 'Agile Walk',
            Icon: <DirectionsWalk color={color} fontSize="large" />,
            onClick: () => agent.requestPostureMode(RobotPostureMode.WalkReady),
            active: postureMode === RobotPostureMode.WalkReady,
            disabled: postureMode === RobotPostureMode.WalkReady
          },
          {
            name: 'Classic',
            Icon: <Hiking color={color} fontSize="large" />,
            onClick: () => agent.requestPostureMode(RobotPostureMode.ClassicWalk),
            active: postureMode === RobotPostureMode.ClassicWalk,
            disabled: false
          },
          {
            name: 'Hello',
            Icon: <WavingHandOutlined color={color} fontSize="large" />,
            onClick: () => agent.requestPostureMode(RobotPostureMode.Gesture),
            active: postureMode === RobotPostureMode.Gesture,
            disabled: false
          },
          {
            name: 'NR',
            Icon: <HelpOutline color={color} fontSize="large" />,
            onClick: () => { },
            active: true,
            disabled: true,
          }
        ]}
      />
      <RobotButton
        color={color}
        id={`robot-button-record`}
        actions={[
          {
            name: 'RecordingOff',
            Icon: <Dvr color={'error'} fontSize="large" />,
            onClick: () => agent.requestRecording(RobotRecordingStatus.Off),
            active: a.recordingStatus === RobotRecordingStatus.Record,
          },
          {
            name: 'RecordingOn',
            Icon: <Dvr fontSize="large" style={{ color: 'gray' }} />,
            onClick: () => agent.requestRecording(RobotRecordingStatus.Record),
            active: a.recordingStatus !== RobotRecordingStatus.Record,
          }
        ]}
      />
      <RobotButton
        color={color}
        id={`robot-button-settings`}
        actions={[
          {
            name: 'Settings',
            Icon: <Settings color={color} fontSize="large" />,
            onClick: () => setCtx({ ...ctx, settingsOpen: true }),
            active: true,
          }
        ]}
      />
      <RobotButton
        color={color}
        actions={[
          {
            name: 'Connect',
            Icon: <Wifi2Bar fontSize='large' style={{ color: 'gray' }} />,
            onClick: () => agent.connect(),
            active: connectionState !== RobotConnectionState.Connected,
            disabled: false
          },
          {
            name: 'Disconnect',
            Icon: <Dangerous color={color} fontSize="large" />,
            onClick: () => agent.disconnect(),
            active: connectionState === RobotConnectionState.Connected,
            disabled: false
          }
        ]}
      />
    </div>
  );
}